<template>
	<div v-if="insertNewActionActive || pasteActionActive"
	     class="layout-divider-controls">
		<b-button v-if="insertNewActionActive"
		          class="control create-button"
		          size="sm"
		          @click="handleCreateClick">
		    +
		</b-button>
		<b-button v-if="pasteActionActive"
		          class="control paste-button"
		          size="sm"
		          @click="handlePasteClick">
			einfügen
		</b-button>
	</div>
</template>

<script>

import InfoText from '@/helper/infoTextHelper';

export default {
	name: 'ErcoLayoutDividerActionBarAtom',
	data() {
		return {};
	},
	props: {
		prevSiteDataset: {
			type: [Object, Boolean],
			default: false,
		},
		nextSiteDataset: {
			type: [Object, Boolean],
			default: false,
		},
	},
	computed: {
		objectsites() {
			return this.$store.state.objectsites;
		},

		insertNewActionActive() {
			if (this.prevSiteDataset) {
				const sitesPerTopicOverMax =
					this.$store.getters.maxSitesPerTopicStatus[this.prevSiteDataset.topicId];
				return !sitesPerTopicOverMax;
			}

			return true;
		},

		currentActionDataObject() {
			return this.$store.state.objectsites.layoutAction.values;
		},

		pasteActionActive() {
			if (this.objectsites.layoutAction.type !== 'move') {
				return false;
			}

			const previousOfSameTopic = (this.prevSiteDataset &&
				this.prevSiteDataset.topicId === this.currentActionDataObject.topicId);
			const nextOfSameTopic = (this.nextSiteDataset &&
				this.nextSiteDataset.topicId === this.currentActionDataObject.topicId);

			if (!previousOfSameTopic && !nextOfSameTopic) {
				return false;
			}

			const actionValues = this.objectsites.layoutAction.values;

			const matchingPrevSiteId =
				this.prevSiteDataset && this.prevSiteDataset.id === actionValues.id;
			const matchingNextSiteId =
				this.nextSiteDataset && this.nextSiteDataset.id === actionValues.id;

			if (matchingPrevSiteId || matchingNextSiteId) {
				return false;
			}

			return true;
		},
		nextSiteNum() {
			let nextSiteNum = 0;
			if (this.prevSiteDataset) {
				nextSiteNum = this.prevSiteDataset.sitenumber + 1;
			} else if (this.nextSiteDataset) {
				nextSiteNum = this.nextSiteDataset.sitenumber;
			}

			return nextSiteNum;
		},
	},
	methods: {
		handleCreateClick() {
			const prevDatasetTopicId = this.prevSiteDataset.topicId;

			const outputData = this.$store.state.objectsites.templates[prevDatasetTopicId];

			if (outputData) {
				this.openSidebarForClickAction(prevDatasetTopicId, outputData);
			} else {
				const contentTopicId = this.$store.state.objectsetup.current.thema_content;
				const contentTopicOutputData = this.$store.state.objectsites.templates[contentTopicId];

				if (contentTopicOutputData) {
					this.openSidebarForClickAction(contentTopicId, contentTopicOutputData);
					return;
				}

				/* Template-Auswahl liegt für das Topic nicht vor, also fragen wir es an */
				this.$store.dispatch('getLayoutTemplatesForTopicId', contentTopicId)
					.then(() => {
						const freshContentTopicOutputData =
							this.$store.state.objectsites.templates[contentTopicId];
						this.openSidebarForClickAction(contentTopicId, freshContentTopicOutputData);
					})
					.catch(() => { /* TODO: Use (better) logging */ });
			}
		},

		openSidebarForClickAction(topicId, outputData) {
			const sidebarData = {
				visible: true,
				key: 'layout-template-selection',
				view: 'erco-sidebar-template-selection',
				fixed: true,
				outputData,
				context: {
					dispatchActionName: 'insertLayoutSite',
					value: {
						sitenumber: this.nextSiteNum,
						topicId,
					},
				},
				styles: {
					width: '70%',
				},
				title: 'Modulauswahl',
				titleAdditional: '',
				info: InfoText.for('layout.createNewSite'),
			};

			this.$store.dispatch('updateSidebar', sidebarData);
		},

		handlePasteClick() {
			const actionInfo = {
				type: this.objectsites.layoutAction.type,
				prevSiteId: this.prevSiteDataset && this.prevSiteDataset.id,
				nextSiteId: this.nextSiteDataset && this.nextSiteDataset.id,
				values: this.objectsites.layoutAction.values,
			};
			this.$store.dispatch('handleSiteAction', actionInfo);
		},
	},
};
</script>

<style lang="scss">

	.layout-divider-controls {
		background-color: rgb(239, 239, 239);
		border: 1px solid black;
		border-left: 0;
		border-right: 0;
		padding: 0.6rem 0 0.6rem 4rem;

		& > .control {
			vertical-align: inherit;
		}
	}

</style>



// WEBPACK FOOTER //
// DividerActionBar.vue?a28c747e